import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  close() {
    document.getElementById("modal_popup_inner").remove();
    document.getElementById("modal_popup").src = "";
  }
  connect() {}
}
